import { Clapperboard, Megaphone, MessageCircle, MonitorDown, Video, type LucideIcon } from 'lucide-react'

/**
 * What a host gets, in the same words and icons wherever it is said: Host a watch-along (/host) and a host invitation
 * (/invite). The icons are the ones hosts see in the app: the host dock's camera, Show my audience's Megaphone, the
 * chat's MessageCircle.
 */
export const HOST_PERKS: readonly { icon: LucideIcon; label: string }[] = [
  { icon: Video, label: 'Your face on screen' },
  { icon: Megaphone, label: 'You call the cameras' },
  { icon: MessageCircle, label: 'Your chat' },
]

/**
 * What a manager runs (a manager invitation on /invite, docs/features/event-managers.md), with the icons the event
 * workspace uses for them: its cameras, OBS setup's MonitorDown, and the watch screen's Clapperboard for the Live show.
 */
export const MANAGER_PERKS: readonly { icon: LucideIcon; label: string }[] = [
  { icon: Video, label: 'Cameras' },
  { icon: MonitorDown, label: 'OBS setup' },
  { icon: Clapperboard, label: 'Live show' },
]
